<template>
    <Loading v-if="isLoading" />
    <div v-else>
        <popup-edit-price-group ref="popupEditPriceGroup" type="Stock" />
        <div class="flex justify-between">
            <p>Price groups are used together with price shift windows to change prices during events.</p>
            <div class="flex justify-end">
                <vs-button icon="add" @click="$refs.popupEditPriceGroup.show()" type="relief" color="primary"
                    class="mr-3">Add price group</vs-button>
            </div>
        </div>
        <!-- table -->
        <div class="data-list-list-view">
            <vs-table ref="table" class="mt-4" :max-items="50" :data="priceGroups">
                <template slot="thead">
                    <vs-th sort-key="name">Name</vs-th>
                    <vs-th sort-key="default">Default price</vs-th>
                    <vs-th sort-key="action">Action</vs-th>
                </template>

                <template slot-scope="{ data }">
                    <tbody>
                        <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
                            <vs-td :data="tr.name">
                                {{ tr.name }}
                            </vs-td>

                            <vs-td :data="tr.isDefault">
                                <code>{{ tr.isDefault | yesno }}</code>
                            </vs-td>

                            <vs-td>
                                <feather-icon icon="TrashIcon" v-if="data.length > 1" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                    class="ml-4" @click.stop="confirmDelete(tr.priceGroupId.id)" />
                                <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                    class="ml-4" @click.stop="$refs.popupEditPriceGroup.show(tr)" />
                            </vs-td>
                        </vs-tr>
                    </tbody>
                </template>
            </vs-table>
        </div>
        <!-- Save & Remove Button -->
        <vs-row>
            <vs-button id="save-button" @click="saveChanges" class="mt-4">Save Changes</vs-button>
        </vs-row>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import ProductIcon from "@/assets/images/product-icon.png";
import popupEditPriceGroup from "./PopupEditPriceGroup.vue";

export default {
    components: { popupEditPriceGroup },
    data() {
        return {
            isLoading: true,
            toDelete: null,
            ProductIcon,
        };
    },
    methods: {
        confirmDelete(id) {
            this.toDelete = id;
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: "Delete price group",
                text: "Are you sure you want to delete this price group?",
                accept: this.deletepriceGroup,
            });
        },
        async saveChanges() {
            this.$vs.loading();
            await this.$store.dispatch("pos/countrySettings/updateCountrySettings");
            this.$vs.loading.close();
        },
        deletepriceGroup() {
            this.$store.commit(
                "pos/countrySettings/deletePriceGroup",
                this.toDelete
            );
            this.toDelete = null;
        },
        async onClickCreateNew() {
            this.$refs.popupEditPriceGroup.show();
        },
    },
    computed: {
        ...mapGetters({
            priceGroups: "pos/countrySettings/priceGroups",
        }),
    },

    async created() {
        this.isLoading = true;
        await Promise.all([
            this.$store.dispatch("pos/countrySettings/getStockWasteReasons"),
        ]);
        this.isLoading = false;
    },
};
</script>